import React, { ReactNode } from 'react';
import { Layout } from 'antd';
import NavBar from './NavBar';
import Footer from './Footer';

type PageWrapperProps = {
    children: ReactNode;
};

function PageWrapper({ children }: PageWrapperProps) {
    return (
        <Layout style={{ height: '100dvh' }}>
            <NavBar />
            <Layout>
                {children}
                <Footer />
            </Layout>
        </Layout>
    );
}

export default PageWrapper;
